export const getAssignmentEdit = (state) => state.assignments.assignmentEdit
export const getAssignmentFormValues = (state) =>
  state.assignments.assignmentFormValues
export const getOfferToEntrepreneur = (state) =>
  state.assignments.offerToEntrepreneur
export const getLatestAssignmentData = (state) =>
  state.assignments.latestAssignmentData
export const getPreviewFormValues = (state) =>
  state.assignments.previewFormValues
export const assignmentRows = (state) => state.assignments.assignmentRows
